import React, { FC, memo, useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/Button/Button'
import { LoginHeader } from '@/components/LoginHeader'
import { DescriptionQr } from '@/components/QrCode/DescriptionQr'
import { QrCode } from '@/components/QrCode/QrCode'
import { icons } from '@/constants/icons'
import { titleData } from '@/constants/login'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import { RegisterSessionProps } from '@/types/componentsPropsTypes'
import { getMainHomePath } from '@/utils/route'

import {
  ButtonWrapper,
  PromoImg,
  PromoWrapper,
  RegisterContainer,
  RegisterWrapper,
  SkipWrapper,
  RegisterQrContainer,
} from './styles'
import { QrWrapperMobileBg } from '../styles'

const RegisterSessionRaw: FC<RegisterSessionProps> = ({
  promotionData,
  code,
  qrUrl,
  qrCodeUrl,
  remainingTime,
}) => {
  const navigate = useNavigate()
  const { t } = useCommonTranslation()

  const [loginHeaderText, setloginHeaderText] = useState<string>(
    t(titleData.created_register.title),
  )

  useEffect(() => {
    promotionData &&
      setloginHeaderText(
        `${t(titleData.created_register.title)} with ${
          promotionData.SCOUPONCODE
        }`,
      )
  }, [promotionData])

  const goToHome = () => navigate(getMainHomePath())

  return (
    <RegisterContainer $promotionData={!!promotionData}>
      {promotionData && (
        <PromoWrapper>
          <PromoImg src={icons.register.promoRegisterImage} alt="" />
        </PromoWrapper>
      )}
      <RegisterWrapper>
        <LoginHeader
          showLogo={false}
          title={loginHeaderText}
          description={t(titleData.created_register.description)}
        />
        <RegisterQrContainer>
          <QrWrapperMobileBg>
            {qrCodeUrl && <QrCode qrPath={qrCodeUrl} />}
          </QrWrapperMobileBg>
          <DescriptionQr
            link={qrUrl}
            code={code}
            mobileStyle={true}
            remainingTime={remainingTime}
          />
        </RegisterQrContainer>
        {promotionData && (
          <ButtonWrapper>
            <SkipWrapper>
              <Button text={t('skip')} onClick={goToHome} />
            </SkipWrapper>
          </ButtonWrapper>
        )}
      </RegisterWrapper>
    </RegisterContainer>
  )
}

export const RegisterSession = memo(RegisterSessionRaw)
